import '../init';
import isInstance from './isInstance';
import windowIsAvailable from './windowIsAvailable';

declare module '../init' {
  export interface CosmosGlobals {
    popoverMap: WeakMap<Element, Set<string>>;
  }
}

if (windowIsAvailable) {
  window.cosmos.popoverMap ??= new WeakMap<Element, Set<string>>();
}

export const popoverMap = windowIsAvailable
  ? window.cosmos.popoverMap
  : new WeakMap<Element, Set<string>>();

const getAllPopovers = (parent: ParentNode): Element[] => {
  const rootNode = parent.getRootNode();

  if (!isInstance(rootNode, Document, DocumentFragment)) return [];

  const popoverTargets = [...parent.querySelectorAll('[data-popover-target]')];

  return popoverTargets.flatMap(el => {
    if (!popoverMap.has(el)) return [];

    const pointerIds = popoverMap.get(el)!;

    const popovers = [...pointerIds].map(id =>
      rootNode.querySelector(`[data-popover-id="${id.replace(/"/g, '\\"')}"]`)
    );

    return popovers.flatMap(popover => (popover ? [popover, ...getAllPopovers(popover)] : []));
  });
};

export default getAllPopovers;
